export default {
  loginCheckUrl: "site/login",
  forgetPasswordUrl: "password/forgot",
  validateTokenUrl: "password/token-verify",
  setTokenPasswordUrl: "password/reset",
  checkEmailExistUrl: "validation/email",
  signupUrl: "site/signup",
  logoutUrl: "site/logout",
  metadataUrl: "settings/get_constant",
  getBasicDetails: "settings/basic_detail",

  upload: "upload/index",
  changePassword: "user/change-password",

  //sensors
  sensorsUrl: {
    listing: "sensors/get-all", //reports/standard-report, sensors/get-all
    getData: "sensorsdata/list",
    liveData: "sensorsdata/live",
    totalData: "sensorsdata/total"
  },

  //reports
  reportsUrl: {
    standard: "reports/standard-report",
    configUrl: {
      list: "reports/config/list",
      save: "reports/config/save",
      delete: "reports/config/delete"
    }
  },

  //alert
  alertsUrl: {
    list: "alert/list",
    save: "alert/save",
    delete: "alert/delete"
  },

  //cycle Report
  cycleReportUrl: {
    list: "reports/cycle-report"
  },

  //user
  userUrl: {
    sendVerificationEmail: "verification-email/send",
    validateVerificationEmailTokenUrl: "verification-email/token-verify"
  },

  //unsubscribe
  unsubscribeUrl: {
    add: "unsubscribe/add"
  }
};
